import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '@frontend-site/shared/data';
import { VOID } from '@frontend-site/shared/utils';
import { SessionRepository } from '../session/session.repository';
import { UsersService } from '../user/users.service';

@Injectable({
    providedIn: 'root'
})
export class SystemUsersResolver  {
    constructor(private sessionStore: SessionRepository, private usersService: UsersService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<[User[], User[]] | void> {
        if (this.sessionStore?.applicationConfig?.companyId) {
            let companyAsNumber = Number(this.sessionStore?.applicationConfig?.companyId);
            return this.usersService.loadCompanyUsers(companyAsNumber);
        }
        return VOID;
    }
}
